import { Component, OnInit } from "@angular/core";
import { AppServerAPI, ServiceResponse } from "@sdbn/common";
import { CameraDefinition, NumberPlateScan } from "../../yard-simulator.model";
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from "@angular/forms";

@Component({
  selector: "app-number-plate-scan",
  templateUrl: "./number-plate-scan.component.html",
  styleUrls: ["./number-plate-scan.component.css"],
})
export class NumberPlateScanComponent implements OnInit {
  cameraSelected: CameraDefinition;
  cameras: CameraDefinition[];

  numberPlateNumber: string;

  formGroup = new FormGroup({});

  constructor(
    private service: AppServerAPI
  ) {
    this.formGroup.addControl("numberPlateNumber", new FormControl("", []));
    this.formGroup.addControl("cameraSelection", new FormControl("", []));
    this.formGroup.valueChanges.subscribe((formValues) => {
      this.numberPlateNumber = formValues.numberPlateNumber;
    });
  }

  ngOnInit() {
    this.service
      .execute<CameraDefinition[]>(
        '/client/admin/yard-simulator/cameras',
        {}
      )
      .subscribe((cameras) => {
        this.cameras = cameras;
      });
  }

  onCameraSelection(camera: CameraDefinition) {
    this.cameraSelected = camera;
  }

  onButtonTrigger() {
    const numberPlateScan = new NumberPlateScan({
      identifier: this.cameraSelected.identifier,
      scannedNumber: this.numberPlateNumber,
    });

    this.service
      .execute<ServiceResponse>(
        '/client/admin/yard-simulator/number-plate-scan',
        numberPlateScan
      )
      .subscribe((response) => {
        console.log(response.status, ":\n", response.responseMessages);
      });
  }
}
